<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport
      [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
      [mode]="(isHandset$ | async) ? 'over' : 'side'"
      [opened]="(isHandset$ | async) === false">
    <mat-toolbar>Menu</mat-toolbar><!-- WHY CANT I SET COLOR HERE? -->
    <mat-nav-list>
      <a mat-list-item routerLinkActive="active-link" [routerLink]="['/nav-campaigns', { outlets: { admeta: ['clients'] } }]">Clients</a>
      <a mat-list-item routerLinkActive="active-link" [routerLink]="['/nav-campaigns', { outlets: { admeta: ['campaign-group-sequence-experiment'] } }]">Campaign Group Sequence Experiment</a>
      <a mat-list-item routerLinkActive="active-link" [routerLink]="['/nav-campaigns', { outlets: { admeta: ['campaign-group-sequence'] } }]">Campaign Groups Sequence</a>
      <a mat-list-item routerLinkActive="active-link" [routerLink]="['/nav-campaigns', { outlets: { admeta: ['campaign-groups'] } }]">Campaign Groups</a>
      <a mat-list-item routerLinkActive="active-link" [routerLink]="['/nav-campaigns', { outlets: { admeta: ['campaigns'] } }]">Campaigns</a>
      <a mat-list-item routerLinkActive="active-link" [routerLink]="['/nav-campaigns', { outlets: { admeta: ['adgroups'] } }]">Ad Groups</a>
      <a mat-list-item routerLinkActive="active-link" [routerLink]="['/nav-campaigns', { outlets: { admeta: ['ads'] } }]">Ads</a>
      <a mat-list-item routerLinkActive="active-link" [routerLink]="['/nav-campaigns', { outlets: { admeta: ['placement-builder'] } }]">Placement Builder</a>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar color="primary">
<!--      @if (isHandset$ | async) {-->
        <button
          type="button"
          aria-label="Toggle sidenav"
          mat-icon-button
          (click)="drawer.toggle()">
          <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
        </button>
<!--      }-->
      <span>heal-angular-adserver {{client_slug}}</span>

      <div style="margin-left: 50px">
        @if (campaign_group_sequence_name) {
          <span>Sequence: {{campaign_group_sequence_name}}</span>
        }
        @if (campaign_group_name) {
          <span> -> Campaign Group: {{campaign_group_name}}</span>
        }
        @if (campaign_name) {
          <span> -> Campaign: {{campaign_name}}</span>
        }
        @if (adgroup_name) {
          <span> -> AdGroup: {{adgroup_name}}</span>
        }
      </div>

    </mat-toolbar>
    <!-- Add Content Here -->
    <router-outlet name="admeta"></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
